export default {"src":"/_next/static/media/doughnuts.647831b4.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};